export default __webpack_public_path__ + "static/media/magicLamp.3e509d5e.png";